import React, { PureComponent } from 'react';
import { css } from 'emotion';

import MessageBox from '../../../../../common/components/core/MessageBox';
import Button from '../../../../../common/components/core/Button';
import DiscoAdsCreatorCustomDropdown from '../CreatorComponents/DiscoAdsCreatorCustomDropdown';

import { DA_CREATOR_FORM_SECTION_COPY } from '../../discoAdsConstants';

import Colors from '../../../../../../styles/Colors';

const styles = {
  manageIntentsButton: css({
    marginRight: '12px',
    borderColor: Colors['@java'],
    color: Colors['@java'],
    borderRadius: '5px'
  }),
  messageBox: css({
    marginBottom: '15px'
  }),
  customSelectContainer: css({
    marginBottom: '15px'
  }),
  customDropdownStyles: {
    control: providedstyling => ({
      ...providedstyling,
      boxSizing: 'border-box',
      border: `1px solid ${Colors['@gallery']}`,
      borderRadius: '6px',
      backgroundColor: Colors['@white']
    })
  }
};

class DiscoAdsTokenizedIntents extends PureComponent {
  _formatIntents = () => {
    const { intents } = this.props;
    return intents.map(intent => {
      return {
        value: intent.name,
        label: intent.pretty_name,
        id: intent.id
      };
    });
  };

  _handleRemoveIntent = remainingIntents => {
    const { intents: previousIntents, onRemoveIntent } = this.props;
    const remainingIntentIds = new Set(
      remainingIntents.map(intent => intent.id)
    );
    previousIntents.forEach(previousIntent => {
      if (!remainingIntentIds.has(previousIntent.id)) {
        return onRemoveIntent(previousIntent.id);
      }
    });
  };

  render() {
    const {
      manageIntentsButton,
      messageBox,
      customSelectContainer,
      customDropdownStyles
    } = styles;
    const { onOpenCloseIntentsModal, intents } = this.props;
    return (
      <div>
        {!intents.length ? (
          <MessageBox
            type="info"
            text={DA_CREATOR_FORM_SECTION_COPY.intents.intents.zeroState}
            className={messageBox}
          />
        ) : (
          <div className={customSelectContainer}>
            <DiscoAdsCreatorCustomDropdown
              multi
              menuIsOpen={false}
              clearable={false}
              testid="da-create-intents"
              options={[]}
              value={this._formatIntents()}
              onChange={this._handleRemoveIntent}
              i13nLabel="Disco Ads Creator - Intents"
              customStyles={customDropdownStyles}
            />
          </div>
        )}
        <Button
          testid="manage-intents"
          type="secondary"
          className={manageIntentsButton}
          onClick={onOpenCloseIntentsModal}
        >
          Manage Intents
        </Button>
      </div>
    );
  }
}

export default DiscoAdsTokenizedIntents;
